export const wrapper = 'bg-white overflow-hidden';
export const content = 'px-4 pb-3';
export const header = 'mt-1 mb-3';
export const text = 'mb-3';
export const linkText = 'flex flex-1 flex-row items-center mb-1 cursor-pointer';
export const icon = 'h-4 w-4 text-primary ml-2';
export const texthover = 'cursor-pointer';
